import { render, staticRenderFns } from "./barcodestockrpt.vue?vue&type=template&id=dadec0a6&scoped=true&"
import script from "./barcodestockrpt.vue?vue&type=script&lang=js&"
export * from "./barcodestockrpt.vue?vue&type=script&lang=js&"
import style0 from "./barcodestockrpt.vue?vue&type=style&index=0&id=dadec0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadec0a6",
  null
  
)

export default component.exports